(function () {
  'use strict';
  var RED = 0xda291c;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dragMoved = false;

  function loadThree(url, cb) {
    if (window.THREE) { cb(); return; }
    var s = document.createElement('script');
    s.src = url; s.async = true; s.onload = cb;
    document.head.appendChild(s);
  }

  function pos(lat, lon) {
    var la = lat * Math.PI / 180, ph = (lon + 180) * Math.PI / 180;
    return { x: -Math.cos(ph) * Math.cos(la), y: Math.sin(la), z: Math.sin(ph) * Math.cos(la) };
  }

  function faceQuat(THREE, lat, lon) {
    var p = pos(lat, lon);
    var rho = Math.sqrt(p.x * p.x + p.z * p.z);
    var a = Math.atan2(p.x, p.z);
    var b = Math.atan2(p.y, rho);
    var qy = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), -a);
    var qx = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0, 0), b);
    return qx.multiply(qy);
  }

  function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  function buildGlobe(root, items, wrap, onPick) {
    var THREE = window.THREE;
    var canvas = wrap.querySelector('canvas');
    var renderer;
    try {
      renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
    } catch (e) { return null; }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    var scene = new THREE.Scene();
    var camera = new THREE.OrthographicCamera(-1, 1, 1, -1, -5000, 5000);
    var group = new THREE.Group();
    scene.add(group);

    var mat = new THREE.ShaderMaterial({
      uniforms: { map: { value: null }, hasMap: { value: 0 } },
      vertexShader: 'varying vec2 vUv; varying vec3 vN; void main(){ vUv = uv; vN = normalize(normalMatrix * normal); gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0); }',
      fragmentShader: 'uniform sampler2D map; uniform float hasMap; varying vec2 vUv; varying vec3 vN; void main(){ float l = 0.16; if (hasMap > 0.5) { vec3 c = texture2D(map, vUv).rgb; l = dot(c, vec3(0.299, 0.587, 0.114)); l = pow(clamp(l * 1.25, 0.0, 1.0), 1.15); } vec3 L = normalize(vec3(-0.55, 0.75, 0.55)); float d = max(dot(normalize(vN), L), 0.0); float rim = smoothstep(0.0, 0.55, vN.z); float v = l * (0.16 + 1.05 * d) * (0.35 + 0.65 * rim); gl_FragColor = vec4(vec3(v), 1.0); }'
    });
    var sphere = new THREE.Mesh(new THREE.SphereGeometry(1, 96, 64), mat);
    group.add(sphere);

    var loader = new THREE.TextureLoader();
    loader.setCrossOrigin('anonymous');
    function setTex(t) {
      t.anisotropy = renderer.capabilities.getMaxAnisotropy();
      mat.uniforms.map.value = t; mat.uniforms.hasMap.value = 1;
      wrap.classList.add('is-ready');
    }
    function loadTex(url, fallback) {
      loader.load(url, setTex, undefined, function () {
        if (fallback && fallback !== url) { loadTex(fallback, null); } else { wrap.classList.add('is-ready'); }
      });
    }
    loadTex(root.getAttribute('data-texture'), root.getAttribute('data-texture-fallback'));

    var redMat = new THREE.MeshBasicMaterial({ color: RED });
    var pins = [];
    var seen = {};
    var itemPin = [];
    items.forEach(function (it, i) {
      var lat = parseFloat(it.getAttribute('data-lat')), lon = parseFloat(it.getAttribute('data-lon'));
      var key = Math.round(lat * 2) + ':' + Math.round(lon * 2);
      if (seen[key] === undefined) {
        var p = pos(lat, lon);
        var g = new THREE.Group();
        g.position.set(p.x, p.y, p.z);
        g.lookAt(p.x * 2, p.y * 2, p.z * 2);
        var dot = new THREE.Mesh(new THREE.SphereGeometry(0.014, 18, 12), redMat);
        dot.position.z = 0.002;
        g.add(dot);
        var rings = [];
        for (var r = 0; r < 2; r++) {
          var rm = new THREE.Mesh(new THREE.RingGeometry(0.019, 0.0215, 48), new THREE.MeshBasicMaterial({ color: RED, transparent: true, opacity: 0, side: THREE.DoubleSide, depthWrite: false }));
          rm.position.z = 0.001;
          g.add(rm); rings.push(rm);
        }
        group.add(g);
        pins.push({ g: g, dot: dot, rings: rings, lat: lat, lon: lon });
        seen[key] = pins.length - 1;
      }
      itemPin[i] = seen[key];
    });

    var pinItem = [];
    itemPin.forEach(function (k, i) { if (pinItem[k] === undefined) { pinItem[k] = i; } });
    var hoverPin = -1;
    var itemZoom = items.map(function (it) {
      var z = parseFloat(it.getAttribute('data-zoom'));
      return (z > 0 ? z : 150) / 100;
    });
    var zoomCur = itemZoom[0] || 1.3;
    var W = 1, H = 1, R = 1;
    function resize() {
      var r = wrap.getBoundingClientRect();
      W = Math.max(r.width, 1); H = Math.max(r.height, 1);
      renderer.setSize(W, H, false);
      camera.left = -W / 2; camera.right = W / 2; camera.top = H / 2; camera.bottom = -H / 2;
      camera.updateProjectionMatrix();
      R = Math.min(W * 0.62, H * 0.95);
      group.scale.setScalar(R * zoomCur);
    }
    resize();
    if (window.ResizeObserver) { new ResizeObserver(resize).observe(wrap); } else { window.addEventListener('resize', resize); }

    var cur = faceQuat(THREE, parseFloat(items[0].getAttribute('data-lat')), parseFloat(items[0].getAttribute('data-lon')));
    group.quaternion.copy(cur);
    var from = cur.clone(), to = cur.clone(), t0 = 0, dur = 1300, flying = false;
    var zFrom = zoomCur, zTo = zoomCur;
    var activePin = itemPin[0];

    var dragging = false, pid = null, lx = 0, ly = 0, vx = 0, vy = 0;
    var AX = new THREE.Vector3(1, 0, 0), AY = new THREE.Vector3(0, 1, 0);
    var qa = new THREE.Quaternion(), qb = new THREE.Quaternion();
    function rot(a, b) {
      qa.setFromAxisAngle(AY, a); qb.setFromAxisAngle(AX, b);
      group.quaternion.premultiply(qa).premultiply(qb).normalize();
    }
    function clampV(v) { return Math.max(-0.2, Math.min(0.2, v)); }
    canvas.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) { return; }
      dragging = true; dragMoved = false; pid = e.pointerId; lx = e.clientX; ly = e.clientY; vx = 0; vy = 0;
      var sx = e.clientX, sy = e.clientY;
      canvas._sx = sx; canvas._sy = sy;
      if (flying) { flying = false; zoomCur = zTo; group.scale.setScalar(R * zoomCur); }
      wrap.classList.add('is-drag');
      try { canvas.setPointerCapture(pid); } catch (err) { /* geen capture mogelijk */ }
      e.preventDefault();
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pid) { return; }
      var k = 1 / (R * zoomCur);
      var dx = e.clientX - lx, dy = e.clientY - ly;
      lx = e.clientX; ly = e.clientY;
      if (Math.abs(e.clientX - canvas._sx) + Math.abs(e.clientY - canvas._sy) > 4) { dragMoved = true; }
      rot(dx * k, dy * k);
      vx = clampV(dx * k); vy = clampV(dy * k);
    });
    function endDrag(e) {
      if (!dragging || (e && e.pointerId !== pid)) { return; }
      dragging = false;
      wrap.classList.remove('is-drag');
      try { canvas.releasePointerCapture(pid); } catch (err) { /* niet nodig */ }
    }
    canvas.addEventListener('pointerup', endDrag);
    canvas.addEventListener('pointercancel', endDrag);
    canvas.addEventListener('lostpointercapture', endDrag);

    var tmpV = new THREE.Vector3();
    function hitPin(e) {
      var r = canvas.getBoundingClientRect();
      var cx = e.clientX - r.left, cy = e.clientY - r.top;
      group.updateMatrixWorld(true);
      var best = -1, bd = 1e9;
      for (var k = 0; k < pins.length; k++) {
        var pp = pins[k].g.position;
        tmpV.set(pp.x, pp.y, pp.z).applyMatrix4(group.matrixWorld);
        if (tmpV.z <= 0) { continue; }
        var dx = (W / 2 + tmpV.x) - cx, dy = (H / 2 - tmpV.y) - cy;
        var d = Math.sqrt(dx * dx + dy * dy);
        if (d < 20 && d < bd) { bd = d; best = k; }
      }
      return best;
    }
    canvas.addEventListener('pointermove', function (e) {
      if (dragging) { return; }
      var k = hitPin(e);
      if (k !== hoverPin) { hoverPin = k; canvas.style.cursor = k > -1 ? 'pointer' : 'default'; }
    });
    canvas.addEventListener('pointerleave', function () { hoverPin = -1; canvas.style.cursor = 'default'; });
    canvas.addEventListener('pointerup', function (e) {
      if (dragMoved || !onPick) { return; }
      var k = hitPin(e);
      if (k > -1 && k !== activePin && pinItem[k] !== undefined) { onPick(pinItem[k]); }
    });

    function goTo(i) {
      var it = items[i]; if (!it) return;
      activePin = itemPin[i];
      to = faceQuat(THREE, parseFloat(it.getAttribute('data-lat')), parseFloat(it.getAttribute('data-lon')));
      zFrom = zoomCur; zTo = itemZoom[i];
      if (reduce) { cur = to.clone(); group.quaternion.copy(cur); zoomCur = zTo; group.scale.setScalar(R * zoomCur); return; }
      from = group.quaternion.clone(); t0 = performance.now(); flying = true;
    }

    var running = false, raf = 0;
    function frame(now) {
      if (!running) return;
      raf = requestAnimationFrame(frame);
      if (flying && !dragging) {
        var t = Math.min((now - t0) / dur, 1);
        var e = ease(t);
        group.quaternion.copy(from).slerp(to, e);
        zoomCur = zFrom + (zTo - zFrom) * e;
        group.scale.setScalar(R * zoomCur * (1 - 0.22 * Math.sin(Math.PI * e)));
        if (t >= 1) { flying = false; zoomCur = zTo; group.scale.setScalar(R * zoomCur); }
      }
      if (!dragging && !flying && (Math.abs(vx) > 0.0004 || Math.abs(vy) > 0.0004)) { rot(vx, vy); vx *= 0.94; vy *= 0.94; }
      var ps = 1 / Math.pow(zoomCur, 0.7);
      pins.forEach(function (p, k) {
        var on = (k === activePin);
        p.dot.scale.setScalar(((on ? 1.7 : 1) * (k === hoverPin ? 1.5 : 1)) * ps);
        p.rings.forEach(function (rm, j) {
          if (!on || reduce) { rm.material.opacity = 0; return; }
          var ph = ((now / 1700) + j * 0.5) % 1;
          rm.scale.setScalar((1 + ph * 3.2) * ps);
          rm.material.opacity = (1 - ph) * 0.85;
        });
      });
      renderer.render(scene, camera);
    }
    function start() { if (running) return; running = true; raf = requestAnimationFrame(frame); }
    function stop() { running = false; cancelAnimationFrame(raf); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { start(); } else { stop(); } }); }, { rootMargin: '100px' }).observe(wrap);
    } else { start(); }
    return { goTo: goTo };
  }

  function Gallery(media) {
    var track = media.querySelector('[data-en-hist-track]');
    if (!track) { return null; }
    var slides = [].slice.call(track.children);
    var n = slides.length;
    if (n < 2) { return null; }
    var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;

    var cFirst = slides[0].cloneNode(true), cLast = slides[n - 1].cloneNode(true);
    cFirst.setAttribute('aria-hidden', 'true'); cLast.setAttribute('aria-hidden', 'true');
    track.insertBefore(cLast, track.firstChild);
    track.appendChild(cFirst);

    var p = 1, timer = 0, visible = true, hovering = false, fallback = 0;
    var chev = function (d) { return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
    var prev = document.createElement('button'), next = document.createElement('button');
    prev.type = 'button'; next.type = 'button';
    prev.className = 'en-hist__arrow en-hist__arrow--prev'; next.className = 'en-hist__arrow en-hist__arrow--next';
    prev.setAttribute('aria-label', en ? 'Previous photo' : 'Vorige foto');
    next.setAttribute('aria-label', en ? 'Next photo' : 'Volgende foto');
    prev.innerHTML = chev('M15 5l-7 7 7 7'); next.innerHTML = chev('M9 5l7 7-7 7');
    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'en-hist__gdots';
    var dots = [];
    for (var d = 0; d < n; d++) { var dt = document.createElement('span'); dt.className = 'en-hist__gdot'; dotsWrap.appendChild(dt); dots.push(dt); }
    media.appendChild(prev); media.appendChild(next); media.appendChild(dotsWrap);

    function idx() { return ((p - 1) % n + n) % n; }
    function paintDots() { var k = idx(); dots.forEach(function (el, i) { el.classList.toggle('is-on', i === k); }); }
    function setPos(pos, animate) {
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translate3d(' + (-pos * 100) + '%,0,0)';
      if (!animate) { void track.offsetWidth; track.style.transition = ''; }
    }
    function normalize() {
      window.clearTimeout(fallback);
      if (p === n + 1) { p = 1; setPos(p, false); }
      else if (p === 0) { p = n; setPos(p, false); }
    }
    track.addEventListener('transitionend', function (e) { if (e.target === track && e.propertyName === 'transform') { normalize(); } });
    function go(delta) {
      normalize();
      p += delta;
      setPos(p, true);
      paintDots();
      if (reduce) { normalize(); } else { fallback = window.setTimeout(normalize, 1200); }
    }
    function schedule() {
      window.clearTimeout(timer);
      if (reduce || !visible || hovering || document.hidden) { return; }
      timer = window.setTimeout(function () { go(1); schedule(); }, 5000);
    }
    prev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); schedule(); });
    next.addEventListener('click', function (e) { e.stopPropagation(); go(1); schedule(); });
    media.addEventListener('mouseenter', function () { hovering = true; window.clearTimeout(timer); });
    media.addEventListener('mouseleave', function () { hovering = false; schedule(); });
    document.addEventListener('visibilitychange', schedule);

    var sx = 0, sy = 0, dx = 0, w = 1, pid = null, dragging = false, decided = false;
    media.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') { return; }
      normalize();
      dragging = true; decided = false; pid = e.pointerId;
      sx = e.clientX; sy = e.clientY; dx = 0; w = media.clientWidth || 1;
      window.clearTimeout(timer);
    });
    media.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pid) { return; }
      dx = e.clientX - sx;
      var dy = e.clientY - sy;
      if (!decided) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) { return; }
        decided = true;
        if (Math.abs(dy) > Math.abs(dx)) { dragging = false; schedule(); return; }
        try { media.setPointerCapture(pid); } catch (err) { /* geen capture */ }
        track.style.transition = 'none';
      }
      track.style.transform = 'translate3d(calc(' + (-p * 100) + '% + ' + dx + 'px),0,0)';
    });
    function endSwipe(e) {
      if (!dragging || (e && e.pointerId !== pid)) { return; }
      dragging = false;
      track.style.transition = '';
      if (!decided) { schedule(); return; }
      var th = Math.max(40, w * 0.18);
      if (dx < -th) { go(1); } else if (dx > th) { go(-1); } else { setPos(p, true); }
      schedule();
    }
    media.addEventListener('pointerup', endSwipe);
    media.addEventListener('pointercancel', endSwipe);

    var loaded = false;
    function eager() {
      if (loaded) { return; }
      loaded = true;
      [].forEach.call(track.querySelectorAll('img'), function (im) { im.loading = 'eager'; });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en2) {
          if (en2.isIntersecting) { eager(); }
          visible = en2.isIntersecting && en2.intersectionRatio >= 0.35;
          schedule();
        });
      }, { threshold: [0, 0.35], rootMargin: '400px 0px' }).observe(media);
    } else { eager(); schedule(); }

    setPos(p, false);
    paintDots();
    return { go: go };
  }

  function init(root) {
    var items = [].slice.call(root.querySelectorAll('[data-en-hist-item]'));
    if (!items.length) return;
    var body = root.querySelector('.en-hist__body');
    var list = root.querySelector('.en-hist__list');
    var wrap = root.querySelector('[data-en-hist-globe]');
    var mq = window.matchMedia('(max-width: 899px)');
    var state = { active: -1, globe: null, pending: -1 };
    var ticking = false;
    var jumping = -1, cancelScroll = false, scrollRaf = 0, booted = false;
    var jumpers = [].slice.call(root.querySelectorAll('[data-en-hist-jump]'));

    items.forEach(function (it) {
      var media = it.querySelector('.en-hist__media');
      if (media) { Gallery(media); }
    });

    function setActive(i) {
      if (i === state.active || i < 0) { return; }
      state.active = i;
      items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); it.classList.toggle('is-passed', k <= i); });
      jumpers.forEach(function (b) { b.classList.toggle('is-active', parseInt(b.getAttribute('data-en-hist-jump'), 10) === i); });
      if (state.globe) { state.globe.goTo(i); } else { state.pending = i; }
    }

    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (jumping === -1) {
        var line = vh * 0.45, best = 0;
        items.forEach(function (it, k) {
          if (it.getBoundingClientRect().top <= line) { best = k; }
        });
        setActive(best);
      }
      if (list) {
        var lr = list.getBoundingClientRect();
        var pr = Math.max(0, Math.min(lr.height, vh * 0.45 - lr.top));
        list.style.setProperty('--en-hist-p', pr + 'px');
      }
      if (wrap && body && !mq.matches) {
        var br = body.getBoundingClientRect();
        var h = wrap.offsetHeight;
        var st = br.top > 0 ? 'top' : (br.bottom < h ? 'bottom' : 'fixed');
        wrap.classList.toggle('is-fixed', st === 'fixed');
        wrap.classList.toggle('is-bottom', st === 'bottom');
        if (st === 'fixed') {
          wrap.style.left = (br.left + br.width / 2) + 'px';
          wrap.style.width = (br.width / 2) + 'px';
        } else { wrap.style.left = ''; wrap.style.width = ''; }
      }
    }
    function req() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }

    function scrollNow(y) {
      try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (err) { window.scrollTo(0, y); }
    }
    function animateTo(y, ms, done) {
      window.cancelAnimationFrame(scrollRaf);
      cancelScroll = false;
      var y0 = window.pageYOffset || document.documentElement.scrollTop, dy = y - y0, t0 = null;
      if (reduce || Math.abs(dy) < 2) { scrollNow(y); done(); return; }
      function step(ts) {
        if (t0 === null) { t0 = ts; }
        var p = Math.min((ts - t0) / ms, 1);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        scrollNow(y0 + dy * e);
        if (p < 1 && !cancelScroll) { scrollRaf = window.requestAnimationFrame(step); } else { done(); }
      }
      scrollRaf = window.requestAnimationFrame(step);
    }
    function jump(i) {
      var it = items[i];
      if (!it) { return; }
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var y = it.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - vh * 0.18;
      y = Math.max(y, 0);
      jumping = i;
      setActive(i);
      var dist = Math.abs(y - (window.pageYOffset || document.documentElement.scrollTop));
      animateTo(y, Math.min(1400, 600 + dist * 0.25), function () { jumping = -1; req(); });
    }
    document.addEventListener('click', function (e) {
      if (dragMoved) { dragMoved = false; return; }
      var t = e.target && e.target.closest ? e.target.closest('[data-en-hist-jump]') : null;
      if (!t && e.detail !== 0 && document.elementsFromPoint) {
        var els = document.elementsFromPoint(e.clientX, e.clientY);
        for (var k = 0; k < els.length; k++) {
          if (els[k].hasAttribute && els[k].hasAttribute('data-en-hist-jump') && root.contains(els[k])) { t = els[k]; break; }
        }
      }
      if (!t || !root.contains(t)) { return; }
      e.preventDefault();
      jump(parseInt(t.getAttribute('data-en-hist-jump'), 10));
    }, true);
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, function () { cancelScroll = true; }, { passive: true });
    });
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    window.addEventListener('load', req);
    update();

    if (wrap) {
      var boot = function () {
        if (booted || mq.matches) { return; }
        booted = true;
        loadThree(root.getAttribute('data-three'), function () {
          state.globe = buildGlobe(root, items, wrap, function (i) { jump(i); });
          if (state.globe && state.pending > -1) { state.globe.goTo(state.pending); }
        });
      };
      if ('IntersectionObserver' in window) {
        var bo = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { boot(); }
        }, { rootMargin: '300px' });
        bo.observe(root);
      } else { boot(); }
      if (mq.addEventListener) { mq.addEventListener('change', function () { boot(); req(); }); }
    }
  }

  if (document.querySelector('[data-en-hist]')) {
    [].forEach.call(document.querySelectorAll('.en-pf'), function (el) { el.style.display = 'none'; });
  }
  [].forEach.call(document.querySelectorAll('[data-en-hist]'), init);
})();
